import { Component, Input, Output, NgZone, ElementRef, EventEmitter, ChangeDetectionStrategy, Directive, Inject, forwardRef, NgModule } from '@angular/core';
import { style, query, stagger, useAnimation, AnimationBuilder } from '@angular/animations';
import { BehaviorSubject, Subscription, fromEvent, merge, of } from 'rxjs';
import { map, filter, switchMap, tap } from 'rxjs/operators';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/animations';
import * as ɵngcc2 from '@angular/common';

function Teximate_p_0_span_1_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const letter_r7 = ctx.$implicit;
    const k_r8 = ctx.index;
    ɵngcc0.ɵɵclassMapInterpolate1("teximate-letter teximate-letter-", k_r8, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", letter_r7, " ");
} }
function Teximate_p_0_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtemplate(1, Teximate_p_0_span_1_span_1_Template, 2, 4, "span", 0);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const word_r4 = ctx.$implicit;
    const j_r5 = ctx.index;
    ɵngcc0.ɵɵclassMapInterpolate1("teximate-word teximate-word-", j_r5, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", word_r4);
} }
function Teximate_p_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵtemplate(1, Teximate_p_0_span_1_Template, 2, 4, "span", 0);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const paragraph_r1 = ctx.$implicit;
    const i_r2 = ctx.index;
    ɵngcc0.ɵɵclassMapInterpolate1("teximate-paragraph teximate-paragraph-", i_r2, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", paragraph_r1);
} }
class Teximate {
    /**
     * @param {?} animationBuilder
     * @param {?} zone
     * @param {?} el
     */
    constructor(animationBuilder, zone, el) {
        this.animationBuilder = animationBuilder;
        this.zone = zone;
        this.el = el;
        /**
         * Stream that emits when animation is started
         */
        this.playEmitter = new EventEmitter();
        /**
         * Stream that emits when animation is done
         */
        this.finishEmitter = new EventEmitter();
        /**
         * Teximate animations
         */
        this.players = new Map();
        /**
         * Teximate state
         */
        this._state = new BehaviorSubject('');
        this.state = this._state.pipe(map((text) => teximateFactory(text)));
    }
    /**
     * Set animated text
     * @param {?} text
     * @return {?}
     */
    set setText(text) {
        this._state.next(text);
    }
    /**
     * @return {?}
     */
    get isPlaying() {
        return this._isPlaying;
    }
    /**
     * @return {?}
     */
    get enterPlayer() {
        return this.players.get('enter');
    }
    /**
     * @return {?}
     */
    get leavePlayer() {
        return this.players.get('leave');
    }
    /**
     * @return {?}
     */
    get defaultPlayer() {
        return this.players.get('default');
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this._isViewInit = true;
        this.updateAnimations(true);
    }
    /**
     * @return {?}
     */
    ngOnChanges() {
        if (this._isViewInit) {
            this.updateAnimations();
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        // TODO: Use players.forEach to destroy players
        if (this.players.has('enter')) {
            this.players.get('enter').destroy();
        }
        if (this.players.has('leave')) {
            this.players.get('leave').destroy();
        }
        if (this.players.has('default')) {
            this.players.get('default').destroy();
        }
    }
    /**
     * Register a new animation
     * @param {?} config
     * @return {?}
     */
    registerAnimation(config) {
        /** @type {?} */
        const player = this.buildAnimation(config).create(this.el.nativeElement);
        /** TODO: Investigate why onStart and onDone fire only once */
        player.onStart(() => {
            this._isPlaying = true;
            this.playEmitter.emit(config.id);
        });
        player.onDone(() => {
            this._isPlaying = false;
            this.finishEmitter.emit(config.id);
        });
        return this.players.set(config.id, player).get(config.id);
    }
    /**
     * @param {?=} autoPlayEnter
     * @return {?}
     */
    updateAnimations(autoPlayEnter) {
        this.zone.runOutsideAngular(() => {
            if (this.enter) {
                /** @type {?} */
                const enterPlayer = this.registerAnimation(Object.assign({}, this.enter, { id: 'enter', isEnter: true }));
                if (autoPlayEnter) {
                    enterPlayer.play();
                }
            }
            if (this.leave) {
                this.registerAnimation(Object.assign({}, this.leave, { id: 'leave' }));
            }
            if (this.animation) {
                this.registerAnimation(Object.assign({ id: 'default' }, this.animation));
            }
        });
    }
    /**
     * Build animation
     * @param {?} config
     * @return {?}
     */
    buildAnimation(config) {
        /** TODO: Use ':enter' and ':leave' for enter and leave animations */
        return this.animationBuilder.build([
            query(`.teximate-${config.type}`, [
                // This is a workaround for enter animation to work
                style({ opacity: config.isEnter ? 0 : 1 }),
                stagger(config.delay, [useAnimation(config.animation)])
            ])
        ]);
    }
}
Teximate.ɵfac = function Teximate_Factory(t) { return new (t || Teximate)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.AnimationBuilder), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
Teximate.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: Teximate, selectors: [["teximate"]], hostAttrs: ["aria-label", "text"], inputs: { setText: ["text", "setText"], enter: "enter", leave: "leave", animation: "animation" }, outputs: { playEmitter: "play", finishEmitter: "finish" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 3, consts: [[3, "class", 4, "ngFor", "ngForOf"]], template: function Teximate_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, Teximate_p_0_Template, 2, 4, "p", 0);
        ɵngcc0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind1(1, 1, ctx.state));
    } }, dependencies: [ɵngcc2.NgForOf, ɵngcc2.AsyncPipe], styles: [".teximate-letter[_ngcontent-%COMP%], .teximate-word[_ngcontent-%COMP%]{display:inline-block}.teximate-word[_ngcontent-%COMP%]{margin-right:8px}"], changeDetection: 0 });
/** @nocollapse */
Teximate.ctorParameters = () => [
    { type: AnimationBuilder },
    { type: NgZone },
    { type: ElementRef }
];
Teximate.propDecorators = {
    setText: [{ type: Input, args: ['text',] }],
    enter: [{ type: Input }],
    leave: [{ type: Input }],
    animation: [{ type: Input }],
    playEmitter: [{ type: Output, args: ['play',] }],
    finishEmitter: [{ type: Output, args: ['finish',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(Teximate, [{
        type: Component,
        args: [{ selector: 'teximate', host: {
                    'aria-label': 'text'
                }, template: "<p *ngFor=\"let paragraph of state | async; index as i\"\r\n   class=\"teximate-paragraph teximate-paragraph-{{i}}\">\r\n\r\n    <span *ngFor=\"let word of paragraph; index as j\"\r\n          class=\"teximate-word teximate-word-{{j}}\">\r\n\r\n     <span *ngFor=\"let letter of word; index as k\"\r\n           class=\"teximate-letter teximate-letter-{{k}}\">\r\n        {{letter}}\r\n      </span>\r\n    </span>\r\n</p>\r\n", changeDetection: ChangeDetectionStrategy.OnPush, styles: [".teximate-letter,.teximate-word{display:inline-block}.teximate-word{margin-right:8px}"] }]
    }], function () { return [{ type: ɵngcc1.AnimationBuilder }, { type: ɵngcc0.NgZone }, { type: ɵngcc0.ElementRef }]; }, { playEmitter: [{
            type: Output,
            args: ['play']
        }], finishEmitter: [{
            type: Output,
            args: ['finish']
        }], setText: [{
            type: Input,
            args: ['text']
        }], enter: [{
            type: Input
        }], leave: [{
            type: Input
        }], animation: [{
            type: Input
        }] }); })();
/**
 * Convert text string into a workable text
 * @param {?} text
 * @return {?}
 */
function teximateFactory(text) {
    /** @type {?} */
    const paragraphs = [];
    // Split text into paragraphs
    text.split('\n').map((paragraph) => {
        /** @type {?} */
        const words = [];
        // Split paragraph into words
        paragraph
            .split(' ')
            .filter(word => word !== '')
            .map((word) => 
        // Split word into letters
        words.push(word.split(/(?!$)/u)));
        paragraphs.push(words);
    });
    return paragraphs;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class TeximateEvents {
    /**
     * @param {?} element
     * @param {?} teximate
     */
    constructor(element, teximate) {
        this.element = element;
        this.teximate = teximate;
        this.events = Subscription.EMPTY;
        this.click = new EventEmitter();
        this.hover = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this.events = this.teximate.state.pipe(filter(() => !!this.click.observers.length || !!this.hover.observers.length), switchMap(() => {
            /** @type {?} */
            let clickEvents = of(null);
            /** @type {?} */
            let hoverEvents = of(null);
            /** @type {?} */
            const words = this.element.nativeElement.querySelectorAll(this.selector);
            if (this.click.observers.length) {
                /** @type {?} */
                const events = Array.from(words).map((el) => fromEvent(el, 'click'));
                clickEvents = merge(...events).pipe(tap(e => this.click.emit(e)));
            }
            if (this.hover.observers.length) {
                /** @type {?} */
                const events = Array.from(words).map((el) => fromEvent(el, 'mouseenter'));
                hoverEvents = merge(...events).pipe(tap(e => this.hover.emit(e)));
            }
            return merge(clickEvents, hoverEvents);
        })).subscribe();
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.events.unsubscribe();
    }
}
TeximateEvents.ɵfac = function TeximateEvents_Factory(t) { return new (t || TeximateEvents)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(forwardRef(() => Teximate))); };
TeximateEvents.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TeximateEvents, outputs: { click: "", hover: "" } });
/** @nocollapse */
TeximateEvents.ctorParameters = () => [
    { type: ElementRef },
    { type: Teximate, decorators: [{ type: Inject, args: [forwardRef(() => Teximate),] }] }
];
TeximateEvents.propDecorators = {
    click: [{ type: Output, args: ['',] }],
    hover: [{ type: Output, args: ['',] }]
};

class ParagraphEvents extends TeximateEvents {
    /**
     * @param {?} element
     * @param {?} teximate
     */
    constructor(element, teximate) {
        super(element, teximate);
        this.click = new EventEmitter();
        this.hover = new EventEmitter();
        this.selector = '.teximate-paragraph';
    }
}
ParagraphEvents.ɵfac = function ParagraphEvents_Factory(t) { return new (t || ParagraphEvents)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(forwardRef(() => Teximate))); };
ParagraphEvents.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ParagraphEvents, selectors: [["teximate", "paragraphClick", ""], ["teximate", "paragraphHover", ""]], outputs: { click: "paragraphClick", hover: "paragraphHover" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
/** @nocollapse */
ParagraphEvents.ctorParameters = () => [
    { type: ElementRef },
    { type: Teximate, decorators: [{ type: Inject, args: [forwardRef(() => Teximate),] }] }
];
ParagraphEvents.propDecorators = {
    click: [{ type: Output, args: ['paragraphClick',] }],
    hover: [{ type: Output, args: ['paragraphHover',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ParagraphEvents, [{
        type: Directive,
        args: [{
                selector: 'teximate[paragraphClick], teximate[paragraphHover]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: Teximate, decorators: [{
                type: Inject,
                args: [forwardRef(() => Teximate)]
            }] }]; }, { click: [{
            type: Output,
            args: ['paragraphClick']
        }], hover: [{
            type: Output,
            args: ['paragraphHover']
        }] }); })();
class WordEvents extends TeximateEvents {
    /**
     * @param {?} element
     * @param {?} teximate
     */
    constructor(element, teximate) {
        super(element, teximate);
        this.click = new EventEmitter();
        this.hover = new EventEmitter();
        this.selector = '.teximate-word';
    }
}
WordEvents.ɵfac = function WordEvents_Factory(t) { return new (t || WordEvents)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(forwardRef(() => Teximate))); };
WordEvents.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: WordEvents, selectors: [["teximate", "wordClick", ""], ["teximate", "wordHover", ""]], outputs: { click: "wordClick", hover: "wordHover" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
/** @nocollapse */
WordEvents.ctorParameters = () => [
    { type: ElementRef },
    { type: Teximate, decorators: [{ type: Inject, args: [forwardRef(() => Teximate),] }] }
];
WordEvents.propDecorators = {
    click: [{ type: Output, args: ['wordClick',] }],
    hover: [{ type: Output, args: ['wordHover',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(WordEvents, [{
        type: Directive,
        args: [{
                selector: 'teximate[wordClick], teximate[wordHover]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: Teximate, decorators: [{
                type: Inject,
                args: [forwardRef(() => Teximate)]
            }] }]; }, { click: [{
            type: Output,
            args: ['wordClick']
        }], hover: [{
            type: Output,
            args: ['wordHover']
        }] }); })();
class LetterEvents extends TeximateEvents {
    /**
     * @param {?} element
     * @param {?} teximate
     */
    constructor(element, teximate) {
        super(element, teximate);
        this.click = new EventEmitter();
        this.hover = new EventEmitter();
        this.selector = '.teximate-letter';
    }
}
LetterEvents.ɵfac = function LetterEvents_Factory(t) { return new (t || LetterEvents)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(forwardRef(() => Teximate))); };
LetterEvents.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: LetterEvents, selectors: [["teximate", "letterClick", ""], ["teximate", "letterHover", ""]], outputs: { click: "letterClick", hover: "letterHover" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
/** @nocollapse */
LetterEvents.ctorParameters = () => [
    { type: ElementRef },
    { type: Teximate, decorators: [{ type: Inject, args: [forwardRef(() => Teximate),] }] }
];
LetterEvents.propDecorators = {
    click: [{ type: Output, args: ['letterClick',] }],
    hover: [{ type: Output, args: ['letterHover',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LetterEvents, [{
        type: Directive,
        args: [{
                selector: 'teximate[letterClick], teximate[letterHover]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: Teximate, decorators: [{
                type: Inject,
                args: [forwardRef(() => Teximate)]
            }] }]; }, { click: [{
            type: Output,
            args: ['letterClick']
        }], hover: [{
            type: Output,
            args: ['letterHover']
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class TeximateModule {
}
TeximateModule.ɵfac = function TeximateModule_Factory(t) { return new (t || TeximateModule)(); };
TeximateModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TeximateModule });
TeximateModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TeximateModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [
                    Teximate,
                    ParagraphEvents,
                    WordEvents,
                    LetterEvents
                ],
                exports: [
                    Teximate,
                    ParagraphEvents,
                    WordEvents,
                    LetterEvents
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TeximateModule, { declarations: function () { return [Teximate, ParagraphEvents, WordEvents, LetterEvents]; }, imports: function () { return [CommonModule]; }, exports: function () { return [Teximate, ParagraphEvents, WordEvents, LetterEvents]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

export { teximateFactory, Teximate, TeximateModule, LetterEvents as ɵd, ParagraphEvents as ɵb, TeximateEvents as ɵa, WordEvents as ɵc };

